import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroManifesto from "./sections/HeroManifesto";
import OurManifesto from "./sections/OurManifesto";
import WhatWeBuild from "./sections/WhatWeBuild";
import GuidesPreview from "./sections/GuidesPreview";
import ClientVoices from "./sections/ClientVoices";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroManifesto />
      <OurManifesto />
      <WhatWeBuild />
      <GuidesPreview />
      <ClientVoices />
      <GetInTouch />
      <Footer />
    </div>;
}